import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Context } from "../../Shared/Context/GlobalContext";
import { useProductCategoriesData } from "../../Shared/Hooks/useProductCategoriesData";
import ProdutCategories from "./__partials/ProductCategories";
import { ModalComponent } from "../Modal";
import { StyledHeader, StyledLogo, StyledExitBtn } from "./style.css";
import { ThemeToggle } from "../ThemeToggle";
import { LanguageSwitcher } from "../LanguageSwitcher";

const Header = () => {
  const { t } = useTranslation();
  const { categories } = useProductCategoriesData();
  const { setSelectedCategory, categoriesLoading, productsLoading, domain } =
    useContext(Context);
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [backModal, setBackModal] = useState(false);

  const shop = domain?.shop || {};
  const shopName = shop.name || "The White Cookie";
  const shopLogo = shop.logo || "/logo192.png";
  const shopSubtitle = shop.subtitle || "";
  const shopUrl = shop.external_url || "#";

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (categoriesLoading || productsLoading) {
    return null;
  }

  if (location.pathname.startsWith("/product/")) {
    return null;
  }

  const hideCategories =
    location.pathname.startsWith("/cart") ||
    location.pathname.startsWith("/account") ||
    location.pathname.startsWith("/checkout");

  return (
    <StyledHeader className="sticky-top">
      <div className="d-flex align-items-center px-3 py-2">
        <div style={{ flex: 1 }}>
          <StyledExitBtn
            className="btn btn-sm rounded-pill"
            variant="outline-secondary"
            size="sm"
            onClick={() => setBackModal(true)}
          >
            {t("Salir")}
          </StyledExitBtn>
        </div>

        <StyledLogo
          src={shopLogo}
          title={shopName}
          alt={shopName}
          className="shop-logo"
          loading="lazy"
        />

        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "0.5rem" }}>
          {isDesktop && shopSubtitle && (
            <span className="small text-muted fw-light">{shopSubtitle}</span>
          )}
          <LanguageSwitcher />
          <ThemeToggle />
        </div>
      </div>

      {!hideCategories && (
        <ProdutCategories
          setSelectedCategory={setSelectedCategory}
          categories={categories}
          isDesktop={isDesktop}
        />
      )}

      <ModalComponent
        show={backModal}
        setShow={setBackModal}
        title={t("Salir de la tienda")}
      >
        <p className="mb-2">
          {t("Si decides volver a la web te redirigiremos hacia allí y guardaremos tu carrito para cuando vuelvas.")}
        </p>
        <p className="fw-bold mb-3">{t("¿Estás seguro/a de que quieres salir?")}</p>
        <div className="d-flex gap-2">
          <Button
            variant="outline-secondary"
            className="w-50 rounded-pill"
            onClick={() => setBackModal(false)}
          >
            {t("No")}
          </Button>
          <a
            href={shopUrl}
            target="_blank"
            rel="noreferrer"
            className="btn btn-dark rounded-pill w-50"
          >
            {t("Sí")}
          </a>
        </div>
      </ModalComponent>
    </StyledHeader>
  );
};

export default Header;
